import * as configuration from './app/configuration';
import * as playerLock from './app/playerLock';
import * as initialization from './app/initialization';
import * as experiment from './app/experiment';
import * as history from './app/history';
import * as storage from './app/storage';
import * as service from './service';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ...configuration,
  ...playerLock,
  ...initialization,
  ...service,
  ...experiment,
  ...history,
  ...storage,
};
